import Tabs from '@fuegokit/react/components/Tabs/Tabs'
import themeGet from '@fuegokit/react/utils/theme-get'
import styled, {keyframes} from 'styled-components'

export const StyledTabs = styled(Tabs)`
  button,
  fieldset,
  input {
    all: unset;
  }
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 0px;
  &[role='tablist'] {
    padding: 0px;
  }
`
export const StyledTabsList = styled(Tabs.List)`
  flex-shrink: 0;
  /* display: flex; */
  /* border-bottom: 1px solid ${themeGet('colors.border.default')}; */
  box-sizing: border-box;
  appearance: none;
  border: none;
  display: flex;
  padding: 0px;
  position: relative;
  font-weight: ${themeGet('fontWeights.medium')};
  &[role='tablist'] {
    padding: 0px;
  }
  &::before {
    content: '';
    border-radius: 2px;
    bottom: -1px;
    margin: 0px;
    position: absolute;
    width: inherit;
    left: ${themeGet('space.2')};
    right: ${themeGet('space.2')};
    height: 2px;
    background-color: ${themeGet('colors.border.default')};
  }
  &[role='tab'] {
    cursor: pointer;
    line-height: 1.8;
    margin: 0px;
    padding: 4px 8px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
export const StyledTabsTrigger = styled(Tabs.Trigger)`
  padding: 0.25rem 0.5rem;

  &[role='tab'] {
    font-family: inherit;
    background-color: ${themeGet('colors.elevation.surface.default.[default]')};
    /* padding: ${themeGet('space.1')} ${themeGet('space.2')}; */
    padding: 0.25rem 0.5rem;
    height: ${themeGet('space.5')};
    /* flex: 1; */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${themeGet('fontSizes.3')};
    line-height: 1.8;
    color: ${themeGet('colors.text.default')};
    user-select: none;
    &:first-child {
      border-top-left-radius: ${themeGet('radii.2')};
    }
    &:last-child {
      border-top-right-radius: ${themeGet('radii.2')};
    }
    &:hover {
      color: ${themeGet('colors.text.default')};
    }
    &[data-state='active'] {
      color: ${themeGet('colors.text.selected')};
      box-shadow: inset 0 -1px 0 0 currentColor, 0 1px 0 0 currentColor;
    }
    &:focus {
      position: relative;
      box-shadow: 0 0 0 2px ${themeGet('colors.border.focused')};
    }
  }
  &[aria-selected='true'] {
    position: relative;
    color: ${themeGet('colors.text.selected')};
    &::after {
      content: '';
      border-radius: 2px;
      bottom: -1px;
      margin: 0px;
      position: absolute;
      width: inherit;
      left: 0;
      right: 0;
      border-bottom: 2px solid ${themeGet('colors.border.selected')};
      height: 0px;
    }
  }
`
export const StyledTabsContent = styled(Tabs.Content)`
  flex-grow: 1;
  padding: ${themeGet('space.2')};
  background-color: ${themeGet('colors.elevation.surface.default.[default]')};
  border-bottom-left-radius: ${themeGet('radii.1')};
  border-bottom-right-radius: ${themeGet('radii.1')};
  outline: none;
  &:focus {
    box-shadow: 0 0 0 2px ${themeGet('colors.border.focused')};
  }
`
// temps
const show = keyframes`
  from {
    opacity: 0; 
    transform: translateY(10px)
  }
  to {
    opacity: 1;
    transform: translateY(0px)
  }
`
//
export const StyledRadixTabs = styled(Tabs)`
  display: flex;
  &[data-orientation='horizontal'] {
    flex-direction: column;
  }
  border: 1px solid ${themeGet('colors.border.inverse')};
  font-family: ${themeGet('fontFamilies.normal')};
  max-width: 20rem;
`
export const StyledRadixTabsList = styled(Tabs.List)`
  flex-shrink: 0;
  // ensures things are layed out correctly by default
  display: flex;
  &[data-orientation='vertical'] {
    flex-direction: column;
  }
  background-color: ${themeGet('colors.elevation.surface.default.[default]')};
`
export const StyledRadixTabsTrigger = styled(Tabs.Trigger)`
  all: unset;
  flex-shrink: 0;
  padding: 0.4em 0.6em;
  font-weight: 500;
  line-height: 1;
  user-select: none;

  &[data-orientation='horizontal'] {
    border-top: 4px solid transparent;
    border-bottom: 4px solid var(--border-color, transparent);
  }

  &[data-orientation='vertical'] {
    padding: 0.6em;
    border-right: 4px solid var(--border-color, transparent);
  }

  &[data-disabled] {
    color: ${themeGet('colors.text.disabled')};
  }

  &[data-state='active'] {
    --border-color: crimson;
  }

  &:focus {
    --border-color: #111;
    outline: 1px solid var(--border-color);
    &[data-state='active'] {
      --border-color: crimson;
    }
  }
`
export const StyledRadixTabsContent = styled(Tabs.Content)`
  flex-grow: 1;
  padding: 1em;
  font-weight: 300;
  font-size: 0.85em;
  line-height: 1.65;
  &[data-orientation='horizontal'] {
    border-top: none;
  }
  &[data-orientation='vertical'] {
    border-left: none;
  }
`
export const StyledRadixAnimatedTabsContent = styled(Tabs.Content)`
  flex-grow: 1;
  padding: 1em;
  font-weight: 300;
  font-size: 0.85em;
  line-height: 1.65;
  &[data-orientation='horizontal'] {
    border-top: none;
  }
  &[data-orientation='vertical'] {
    border-left: none;
  }
  &[data-state='active'] {
    animation: ${show} 400ms ease;
  }
`
export const StyledRadixTabsRootAttr = styled(Tabs)`
  background-color: rgba(0, 0, 255, 0.3);
  border: 2px solid blue;
  padding: 10;

  &:disabled {
    opacity: 0.5;
  }
  &[data-disabled] {
    border-style: dashed;
  }

  &[data-state='inactive'] {
    border-color: red;
  }
  &[data-state='active'] {
    border-color: green;
  }
`
export const StyledRadixTabsListAttr = styled(Tabs.List)`
  background-color: rgba(0, 0, 255, 0.3);
  border: 2px solid blue;
  padding: 10;

  &:disabled {
    opacity: 0.5;
  }
  &[data-disabled] {
    border-style: dashed;
  }

  &[data-state='inactive'] {
    border-color: red;
  }
  &[data-state='active'] {
    border-color: green;
  }
`
export const StyledRadixTabsTriggerAttr = styled(Tabs.Trigger)`
  background-color: rgba(0, 0, 255, 0.3);
  border: 2px solid blue;
  padding: 10;

  &:disabled {
    opacity: 0.5;
  }
  &[data-disabled] {
    border-style: dashed;
  }

  &[data-state='inactive'] {
    border-color: red;
  }
  &[data-state='active'] {
    border-color: green;
  }
`
export const StyledRadixTabsContentAttr = styled(Tabs.Content)`
  // ensure we can see the content (because it has hidden attribute)
  display: block;
  background-color: rgba(0, 0, 255, 0.3);
  border: 2px solid blue;
  padding: 10;

  &:disabled {
    opacity: 0.5;
  }
  &[data-disabled] {
    border-style: dashed;
  }

  &[data-state='inactive'] {
    border-color: red;
  }
  &[data-state='active'] {
    border-color: green;
  }
`
export const StyledDemoTabsList = styled(Tabs.List)`
  display: flex;
  border-bottom: 1px solid ${themeGet('colors.border.default')};
  gap: ${themeGet('space.4')};
`
export const StyledDemoTabsTrigger = styled(Tabs.Trigger)`
  cursor: pointer;
  background-color: transparent;
  border: none;
  line-height: 1.8;
  margin: 0px;
  padding: ${themeGet('space.2')} 0;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${themeGet('colors.text.subtle')};
  border-bottom: 2px solid transparent;

  &[aria-selected='true'] {
    color: ${themeGet('colors.text.selected')};
    border-bottom: 2px solid ${themeGet('colors.border.selected')};
  }
`
